import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { loadReportsParams, OrderHistoryResultModel } from "@tKgpco/Services/ReportsService";
import { ReportHistoryState } from "@tKgpco/Store/Data/ReportHistory/ReportHistoryState";
import { Draft } from "immer";

const initialState: ReportHistoryState = {
    isLoading: false,
    reportHistoryParams: null,
    reportHistoryCollection: null,
};
export const reducer = {
    "Custom/ReportHistory/DispatchBeginLoadReportHistory": (
        draft: Draft<ReportHistoryState>,
        action: { params: loadReportsParams },
    ) => {
        draft.isLoading = true;
        draft.reportHistoryParams = action.params;
    },

    "Custom/ReportHistory/CompleteSmartSupplyCartsList": (
        draft: Draft<ReportHistoryState>,
        action: { result: OrderHistoryResultModel },
    ) => {
        draft.isLoading = false;
        draft.reportHistoryCollection = action.result;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
